<template>
  <label class="toggle-switch" :id="`switch-${elementId}`">
    <input
      :id="`input-${elementId}`"
      type="checkbox"
      :checked="checked"
      :value="value"
      :disabled="isDisabled"
      v-bind="{ ...(tabIndex && { tabindex: tabIndex }) }"
      :aria-checked="checked.toString()"
      :aria-labelledby="`switch-${elementId}`"
      role="switch"
      @change="onCheckBoxUpdate"
    />
    <span class="toggle-switch-slider"></span>
  </label>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    value: {
      type: [Boolean, String],
      required: true,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    tabIndex: {
      type: [String, null],
      default: null,
    },
    elementId: {
      type: [String, Number],
      default: '',
    },

    brandedStyle: { type: Object, default: () => {} },
  },
  methods: {
    onCheckBoxUpdate(event) {
      this.checked = event.target.checked;
    },
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    getPrimaryBrandColor() {
      return this?.brandedStyle?.primaryBrandColor || '#000000';
    },
  },
};
</script>

<style scoped>
.toggle-switch {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 26px;
}

.toggle-switch input {
  display: none;
}

.toggle-switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 19px;
  transition: background-color 0.2s ease-in-out;
}

.toggle-switch-slider:before {
  position: absolute;
  content: '';
  height: 22px;
  width: 22px;
  left: 2px;
  bottom: 2px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.2s ease-in-out;
}

.toggle-switch input:checked + .toggle-switch-slider {
  background-color: v-bind(getPrimaryBrandColor);
}

.toggle-switch input:checked + .toggle-switch-slider:before {
  transform: translateX(24px);
}

.toggle-switch input:not(:checked):disabled + .toggle-switch-slider,
.toggle-switch input:checked:disabled + .toggle-switch-slider {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
